import ApexCharts from 'apexcharts';
import { useEffect, useRef } from 'react';

const PieChart = ({ chartData }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartData?.series?.length || !chartData?.labels?.length) return;

    const chart = new ApexCharts(chartRef.current, {
      series: chartData.series,
      chart: {
        height: 350,
        type: 'pie'
      },
      labels: chartData.labels
    });

    chart.render();

    return () => chart.destroy();

  }, [chartData]);

  return <div ref={chartRef}></div>;
};

export default PieChart;
